import actions from '../actions/actions';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
